import { render, staticRenderFns } from "./UnlockIcon.vue?vue&type=template&id=6a9c5ac0"
import script from "./UnlockIcon.vue?vue&type=script&lang=js"
export * from "./UnlockIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports